const MULAW_BIAS = 33;

function decodeMuLawSample(value: number) {
  const uval = (~value) & 0xff;
  const sign = uval & 0x80;
  const exponent = (uval >> 4) & 0x07;
  const mantissa = uval & 0x0f;
  const sample = ((mantissa << 4) + 0x08) << exponent;
  const pcm = sample - MULAW_BIAS;
  return sign ? -pcm : pcm;
}

function base64ToBytes(base64: string) {
  const binary = atob(base64);
  const length = binary.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function decodeMuLawBase64ToFloat32(base64: string) {
  const bytes = base64ToBytes(base64);
  const output = new Float32Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) {
    const pcm = decodeMuLawSample(bytes[i]);
    output[i] = Math.max(-1, Math.min(1, pcm / 32768));
  }
  return output;
}

export function resampleLinear(
  input: Float32Array,
  inputRate: number,
  outputRate: number
) {
  if (inputRate === outputRate) {
    return input;
  }
  const ratio = outputRate / inputRate;
  const outputLength = Math.max(1, Math.round(input.length * ratio));
  const output = new Float32Array(outputLength);
  for (let i = 0; i < outputLength; i += 1) {
    const position = i / ratio;
    const index = Math.floor(position);
    const nextIndex = Math.min(index + 1, input.length - 1);
    const frac = position - index;
    output[i] = input[index] * (1 - frac) + input[nextIndex] * frac;
  }
  return output;
}
